import { bigQuery } from '@fiverr-private/obs';
import { GROUPES, SOURCE_PAGE_LOGO_MAKER_FORK } from '../constants';
import { getBQPayload } from '../utils';

export const trackForkIsShown = () => {
    bigQuery.send(
        getBQPayload({
            type: 'logo_maker_fork_is_shown',
            group: GROUPES.USERS_IMRESSIONS,
            gig_impression: {
                sourcepage: SOURCE_PAGE_LOGO_MAKER_FORK,
            },
        })
    );
};
